import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartConfiguration, ChartData, ChartEvent, ChartOptions } from 'chart.js';
import { UtilService } from 'src/app/services/util.service';
import { BarChartConfig } from 'src/app/models/ChartConfig';
import { ActiveElement } from 'chart.js/dist/plugins/plugin.tooltip';
import { Chart } from 'chart.js/dist';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './app-bar-chart.component.html',
  styleUrls: ['./app-bar-chart.component.scss'],
})
export class AppBarChartComponent implements OnInit {

  @Input() chartConfig = new BarChartConfig;
  @Input() chartHeight = 22;
  @Input() type: string;
  @Input() noDataAdapt = false;
  @Output() chartClick = new EventEmitter<any>();

  constructor(
    public utilService: UtilService
  ) { }

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        suggestedMax: 20,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        labels: {
          usePointStyle: true,
        }
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },

  };
  public barChartType = 'bar' as const;


  public barChartData: ChartData<'bar'>
    = {
      labels: [],
      datasets: [],
    };

  // events
  public chartClicked(event: { event?: ChartEvent; active?: any[] }): void {
    if (!event.event) return;

    const chart = (event.event as any).chart as Chart;

    // Coordinate del click
    const x = (event.event.native as MouseEvent).offsetX;

    // Recupera la scala X
    const xScale = chart.scales['x'];

    // Trova l'indice del mese in base alla posizione X
    const index = xScale.getValueForPixel(x);

    // Arrotonda all'intero più vicino
    const monthIndex = Math.round(index);

    // Etichetta del mese
    const label = chart.data.labels?.[monthIndex] as string;

    this.chartClick.emit(label);
  }

  public chartHovered({
    event,
    active,
  }: {
    event?: ChartEvent;
    active?: object[];
  }): void {
  }

  ngOnInit() {

    const datasetOptions = {
      categoryPercentage: 0.8,
      barPercentage: 0.5,
    };

    if (!this.chartConfig?.chartColors || this.chartConfig?.chartColors.length === 0) {
      this.chartConfig.chartColors = this.utilService.chartColors;
    }

    // Ora puoi impostare i labels e i datasets insieme, includendo i colori
    this.barChartData.labels = this.chartConfig.data.labels_bar;
    const colors = this.chartConfig.chartColors; // Assumi che sia un array di colori

    this.barChartData.labels = this.chartConfig.data.labels_bar;
    const dataSeries = [];
    if (this.chartConfig.data.first_bar) {
      dataSeries.push({
        data: this.chartConfig.data.first_bar,
        label: this.chartConfig.labels[0]
      });
    }

    if (this.chartConfig.data.second_bar) {
      dataSeries.push({
        data: this.chartConfig.data.second_bar,
        label: this.chartConfig.labels[1]
      });
    }

    if (this.chartConfig.data.third_bar) {
      dataSeries.push({
        data: this.chartConfig.data.third_bar,
        label: this.chartConfig.labels[2]
      });
    }

    this.barChartData.datasets = dataSeries.map((series, index) => ({
      ...datasetOptions,
      data: series.data,
      label: series.label,
      backgroundColor: this.chartConfig.chartColors[index] || 'grey',
      borderColor: this.chartConfig.chartColors[index] || 'grey',
      borderRadius: 20
    }));

    this.updateYAxisMax();
    this.configureChartOptions();

  }

  updateYAxisMax() {
    const maxValues = this.chartConfig.data.first_bar
      .concat(this.chartConfig.data.second_bar)
      .concat(this.chartConfig.data.third_bar)
      .map(Number)
      .filter(value => !isNaN(value));

    const maxValue = Math.max(...maxValues);
    const suggestedMax = maxValue + (maxValue * 0.1);

    this.barChartOptions.scales['y'].suggestedMax = Math.max(20, suggestedMax);
  }

  configureChartOptions() {
    if (this.type === 'YEAR' || this.type === '3M') {
      if (!this.barChartOptions.scales) {
        this.barChartOptions.scales = {};
      }

      if (!this.barChartOptions.scales['x']) {
        this.barChartOptions.scales['x'] = { type: 'category' };
      }
      if (!this.noDataAdapt) {
        this.barChartOptions.scales['x'].ticks = {
          callback: (val, index) => {
            // Usa l'indice per ottenere l'etichetta effettiva dall'array delle etichette
            const label = String(this.barChartData.labels[index]);
            if (label) {
              const [year, month] = label.split('-');
              const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, 1));
              let formatted = date.toLocaleString('it-IT', {
                month: 'short',
                year: 'numeric'
              });
              formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
              return this.utilService.translate.instant(formatted);
            }
            return '';
          }
        };
      }
    }
  }



}
